<template>
    <form @submit.prevent="update">
        <div class="modal-body modal-open modal-height-max modal-row2 change-password-modal-body" style="max-height: 66vh" v-if="profile">
            <SectionCardComponent
                    eyebrow="Segurança"
                    title="Alteração de senha"
                    subtitle="Atualize sua senha de acesso com segurança."
                    icon="icon-lock"
                    custom-class="change-password-section-card change-password-profile-card">
                <div class="change-password-profile-panel">
                    <div class="avatar-size avatar change-password-avatar" v-if="!widthPhone()">
                        <img class="user-avatar" :src="imageCropped ? imageCropped : profile.avatar">
                    </div>
                    <div class="change-password-profile-copy">
                        <strong>{{ profile.name }}</strong>
                        <span>{{ profile.email }}</span>
                    </div>
                </div>
            </SectionCardComponent>

            <SectionCardComponent
                    eyebrow="Senha"
                    title="Dados da nova senha"
                    subtitle="Informe a senha atual e confirme a nova senha desejada."
                    icon="icon-lock"
                    custom-class="change-password-section-card">
                <div class="change-password-fields">
                    <div class="form-group">
                        <label for="currentPassword">{{ t('GENERAL.CURRENT_PASSWORD') }}: </label>
                        <input data-cy="change_password_current" class="form-control"
                               type="password" autocomplete="off" name="currentPassword" id="currentPassword"
                               placeholder="Insira a senha atual" v-model="this.currentPassword">
                    </div>
                    <div class="form-group">
                        <label for="password">{{ t('GENERAL.NEW_PASSWORD') }}: </label>
                        <input data-cy="login_creat_password_confirm" class="form-control"
                               type="password" autocomplete="off"
                               id="password" v-model="newPassword" name="password"
                               placeholder="Insira nova senha"
                               @keyup="inputPassword(this.newPassword, this.passwordConfirm)"/>
                    </div>
                    <div class="form-group mb-0">
                        <label for="passwordConfirm">{{ t('GENERAL.CONFIRM_NEW_PASSWORD') }}: </label>
                        <input data-cy="login_creat_password_confirm" class="form-control"
                               type="password" id="passwordConfirm" autocomplete="off"
                               v-model="passwordConfirm" name="passwordConfirm" placeholder="Confirmar senha"
                               @keyup="inputPassword(this.newPassword, this.passwordConfirm)"/>
                        <div class="validation" id="invalidPassword" style="display: none">{{ msgPassword }}</div>
                        <small id="passwordHelpInline" class="text-muted change-password-help-text">
                            {{ t('GENERAL.MSG.MAX_MIN_PASSWORD') }}
                        </small>
                    </div>
                </div>
            </SectionCardComponent>
        </div>
        <div class="modal-footer justify-content-right">
            <button data-cy="profile_update_modal_close" id="closeModal" class="btn btn-secondary" data-dismiss="modal"
                    type="button" @click="closeFirstModal()">{{ t('ACTIONS.CLOSE') }}
            </button>
            <button data-cy="profile_update_modal_confirm" class="btn btn-primary" type="submit">{{
                    t('ACTIONS.CONFIRM')
                }}
            </button>
        </div>
    </form>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import User from '@/services/user';
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import SectionCardComponent from '@/components/layouts/SectionCardComponent.vue';

export default {
    name: 'passwordModal',
    props: ['profileIndex'],
    mixins: [Validate],
    components: {SectionCardComponent},


    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },

    computed: {
        ...mapState({
            imageCropped: 'imageCropped',
        }),
    },

    data() {
        return {
            profile: null,
            currentPassword: null,
            newPassword: null,
            passwordConfirm: null,
        }
    },
    emits:['update'],
    mounted() {
        this.profile = this.profileIndex;
    },

    watch: {
        profileIndex: function () {
            this.profile = this.profileIndex;
        }
    },

    methods: {
        update() {
            this.invalid = [];
            this.passwordValidade(this.newPassword, this.passwordConfirm);

            if (this.invalid.length == 0) {
                this.isLoading = true;
                this.startForm();

                User.resetPasswordLogged(this.form).then(() => {
                    this.isLoading = false;
                    this.cleanField();
                    document.getElementById('closeModal').click();
                    this.toast.success('Senha Atualizada');

                }).catch((err) => {
                    this.isLoading = false;
                    this.cleanField();
                    this.errorMsg(err);
                    return false;
                });
            }
        },

        startForm() {
            this.form = {
                currentPassword: this.currentPassword,
                password: this.newPassword,
            }
        },

        cleanField() {
            document.getElementById('currentPassword').value = '';
            document.getElementById('password').value = '';
            document.getElementById('passwordConfirm').value = '';
        },

        inputPassword(password, passwordConfirm, isSingup = true) {
            document.getElementById("invalidPassword").style.color = "red";
            document.getElementById("password").classList.remove("is-valid");
            document.getElementById("invalidPassword").style.display = "none";
            document.getElementById("password").classList.remove("is-invalid");
            document.getElementById("passwordConfirm").classList.remove("is-valid");
            document.getElementById("passwordConfirm").classList.remove("is-invalid");
            this.passwordValidade(password, passwordConfirm, isSingup);
            if (this.passwordConfirm) {
                this.passwordConfirm = this.passwordConfirm.trim();
            }
            if (this.newPassword) {
                this.newPassword = this.newPassword.trim();
            }
        },

        passwordValidade(password, passwordConfirm, isSingup = true) {
            if (!password) {
                this.invalid.push(true);
                this.msgPassword = this.t("GENERAL.MSG.REQUIRED_FIELD");
                document.getElementById("password").classList.add("is-invalid");
                document.getElementById("invalidPassword").style.display = "block";
            }

            if (isSingup && !passwordConfirm) {
                this.invalid.push(true);
                this.msgPassword = this.t("GENERAL.MSG.REQUIRED_FIELD");
                document.getElementById("invalidPassword").style.display = "block";
                document.getElementById("passwordConfirm").classList.add("is-invalid");
            }

            this.validateEqualityPassword(password, passwordConfirm);
        },

        validateEqualityPassword(password, passwordConfirm) {
            if (password != passwordConfirm) {
                this.invalid.push(true);
                this.msgPassword = this.t("GENERAL.MSG.DIFFERENT_PASSWORDS");
                document.getElementById("password").classList.add("is-invalid");
                document.getElementById("invalidPassword").style.display = "block";
                document.getElementById("passwordConfirm").classList.add("is-invalid");
            } else {
                this.passwordStrength(password);

                if (this.invalid.length == 0) {
                    document.getElementById("password").classList.add("is-valid");
                    document.getElementById("passwordConfirm").classList.add("is-valid");
                }
            }
        },

        passwordStrength(password) {
            var numbers = /([0-9])/;
            var alphabet = /([a-zA-Z])/;
            var spCharacter = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;

            if (password) {
                if (password.length < 8) {
                    this.invalid.push(true);
                    this.msgPassword = this.t("GENERAL.MSG.PASSWORD_TO_SMALL");
                    document.getElementById("password").classList.add("is-invalid");
                    document.getElementById("invalidPassword").style.display = "block";
                    document
                            .getElementById("passwordConfirm")
                            .classList.add("is-invalid");
                } else if (password.length > 20) {
                    this.invalid.push(true);
                    this.msgPassword = this.t("GENERAL.MSG.PASSWORD_TO_LONG");
                    document.getElementById("password").classList.add("is-invalid");
                    document.getElementById("invalidPassword").style.display = "block";
                    document
                            .getElementById("passwordConfirm")
                            .classList.add("is-invalid");
                } else {
                    if (
                            password.match(numbers) &&
                            password.match(alphabet) &&
                            password.match(spCharacter)
                    ) {
                        this.msgPassword = this.t("GENERAL.MSG.PASSWORD_STRONG");
                        document.getElementById("invalidPassword").style.color = "green";
                        document.getElementById("invalidPassword").style.display = "block";
                    } else if (
                            password.match(alphabet) &&
                            password.match(numbers) &&
                            !password.match(spCharacter)
                    ) {
                        this.msgPassword = this.t("GENERAL.MSG.PASSWORD_MEDIUM");
                        document.getElementById("invalidPassword").style.color = "orange";
                        document.getElementById("invalidPassword").style.display = "block";
                    } else if (
                            (password.match(alphabet) &&
                                    !password.match(numbers) &&
                                    !password.match(spCharacter)) ||
                            (!password.match(alphabet) &&
                                    password.match(numbers) &&
                                    !password.match(spCharacter))
                    ) {
                        this.invalid.push(true);
                        this.msgPassword = this.t("GENERAL.MSG.PASSWORD_WEAK");
                        document.getElementById("password").classList.add("is-invalid");
                        document.getElementById("invalidPassword").style.display = "block";
                        document
                                .getElementById("passwordConfirm")
                                .classList.add("is-invalid");
                    }
                }
            }
        },

        checkForm() {
            this.nameValidate(this.profile.name);

            if (!this.profile.phones[0]) {
                this.toast.error(this.t('GENERAL.MSG.ADD_ONE_PHONE'), {timeout: false})
                return false;
            }

            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            return true;
        },

        uploadImage() {
            const file = document.querySelector('input[type=file]').files[0]
            const reader = new FileReader()

            reader.onloadend = () => {
                this.isCropping = true;
                this.$store.commit('setImage', reader.result);
                document.getElementById('imageCropper').click();
            }

            reader.readAsDataURL(file);
        },

        updatePhone(phones) {
            this.profile.phones = phones;
        },

        closeFirstModal() {
            if (localStorage.getItem('firstProfileClosed') == "true") {
                this.$emit('update');
                localStorage.setItem('firstProfileClosed', false);
            }
        }
    }
}
</script>

<style scoped>
.change-password-modal-body {
    padding: 0 1rem 1rem !important;
}

.change-password-section-card {
    margin-bottom: 12px !important;
}

.change-password-profile-panel {
    align-items: center;
    background: rgba(231, 244, 240, 0.52);
    border: 1px solid rgba(14, 94, 78, 0.08);
    border-radius: 14px;
    display: flex;
    gap: 1rem;
    padding: 0.9rem 1rem;
}

.change-password-avatar {
    flex: 0 0 auto;
    margin: 0 !important;
}

.change-password-profile-copy {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.change-password-profile-copy strong {
    color: #173b34;
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.change-password-profile-copy span {
    color: #6b7c78;
    font-size: 0.82rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.change-password-fields {
    margin: 0 auto 12px;
    max-width: 420px;
}

.change-password-help-text {
    display: block;
    margin-top: 0.45rem;
}

:global(html.dark-theme .change-password-profile-panel) {
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border) !important;
}

:global(html.dark-theme .change-password-profile-copy strong) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .change-password-profile-copy span) {
    color: var(--dark-text-soft) !important;
}

@media (max-width: 575px) {
    .change-password-profile-panel {
        align-items: center;
        flex-direction: column;
        text-align: center;
    }

    .change-password-profile-copy {
        max-width: 100%;
    }
}
</style>
